export enum AccountTypes {
    Candidate,
    Employer
}